import { Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { SignatureCompletionImage } from "../../components/SvgComponents/SignatureCompletionImage/SignatureCompletionImage";

export const OtpResendRejected = () => {
  const { t } = useTranslation();

  return (
    <Container>
      <Row className="container-row">
        <Col md={2}></Col>
        <Col md={8} xs={12} className="justify-content-center container-box">
          <Row style={{ display: "flex", flexDirection: "column" }}>
            <SignatureCompletionImage />
            <p style={{ fontSize: "28px", fontWeight: "900", lineHeight: "30px", marginTop: "10%" }}>
              {t('wizard.otp_resend_rejected_title')}
            </p>
            <span> {t('wizard.otp_resend_rejected_description')} </span>
          </Row>
        </Col>
        <Col md={2}></Col>
      </Row >
    </Container >
  );
};
